import axios from 'axios';

const SERVER_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:44444/api'
    : `${process.env.REACT_APP_PROTOCOL}://${window.location.hostname}:${process.env.REACT_APP_PORT_API}/api`;

export const ApiClient = axios.create({
  baseURL: SERVER_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000
});

export const ApiErrorMessage = (e: unknown) => {
  if (axios.isAxiosError(e)) {
    return e.response;
  }
  return null;
};
